import React from 'react';
import { LayoutItem } from 'react-grid-layout';
import { ReactComponent as LowTempIcon } from '../../../../../../../../assets/dashboard/LowTemp.svg';
import {
  ILabelValuePanel,
  ILowTempPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel, {
  DefaultRightContainer,
} from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { useTranslation } from 'react-i18next';
import useLowTempAlarms from './useLowTempAlarms';

export interface LowTempPanelProps {
  panel: ILowTempPanel;
  layout?: LayoutItem | undefined;
}

function LowTempPanel(props: LowTempPanelProps) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const { isLoading, error, count } = useLowTempAlarms(panel);

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `low_temp`,
    title: panel.title,
    icon: <LowTempIcon height={'100%'} />,
    content: (
      <DefaultRightContainer success={count === 0}>
        {count ?? 0}
      </DefaultRightContainer>
    ),
    loading: isLoading,
    error: error ? t('dashboard.error.fetching') : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default LowTempPanel;
